import { useMutation } from '@tanstack/react-query'
import { serverURL } from '../api/config'

export interface RequestJoinResult {
  email_sent: boolean
}

export function useRequestJoin() {
  return useMutation({
    mutationFn: async ({
      token,
      orgUuid,
    }: {
      token: string
      orgUuid: string
    }): Promise<RequestJoinResult> => {
      const response = await fetch(
        `${serverURL}/onboarding-progress/${orgUuid}/request-join`,
        {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}` },
        }
      )

      if (!response.ok) {
        throw new Error(`Request-join failed: ${response.statusText}`)
      }

      return response.json()
    },
  })
}
